import { createFileRoute, redirect } from '@tanstack/react-router'

// Billing index redirects to credits page
export const Route = createFileRoute('/billing/')({
  beforeLoad: () => {
    throw redirect({ to: '/billing/credits' })
  },
})
